/// JTF3-added-AB-22-04-06


jQuery(document).ready(function($) {
	function POPUP( thisInstance ) {
		console.log('JTF Popup Block V1.0.2');
		this.instance = thisInstance
		this.init();
	}
	
	/**
	 * Default actions happening on device actions
	 */
	POPUP.prototype.init = function () {
		const self = this;
		
		let thisId = this.instance.attr('data-blockid')
		let time = this.instance.attr('data-timeout')
		
		setTimeout(function(){
			self.instance.fadeIn();
		},time );
		
		
		if ( localStorage.getItem(thisId) == 'true' ) {
			self.instance.remove();
		}
		
		this.instance.find('.jtf__popupblock--close').on('click', function(){
			console.log('Popup Dismissed');
			
			self.instance.remove();
			
			localStorage.setItem(thisId, true);
		})
		
	};
	
	// Check POPUP is used on this page before instantiating
	if ($('.wp-block-jtf-jtf-popup').length > 0) {
		// instantiate a new google maps API for each gmap block
		$('.wp-block-jtf-jtf-popup').each(function() {
			const eventsGmap = new POPUP( $(this) );
		});
	}
});
